import Image from 'next/image';
import React from 'react';

import styles from './direct-entry.module.scss';

interface DirectEntryProps {
    height?: number;
    publicId: string;
}

const DirectEntry = (props: DirectEntryProps) => {
    const { publicId, height = 28 } = props;

    return (
        <>
            {publicId && (
                <div style={{ height: height }} className={styles.direct_entry_container}>
                    <Image src={`/svg/direct-entry/${publicId}.svg`} alt={`${publicId}`} objectFit="contain" layout="fill" />
                </div>
            )}
        </>
    );
};

export default DirectEntry;
